<template>
  <div class="row">
    

    <div class="col-md-12 modal-body-expense">
      <div class="row" style="padding: 5px;">
        <div class="col-md-12">
          <!-- <div class="alert alert-danger" v-if="errors.length">
                  <strong>Whoops!</strong> There were some problems with your input.<br><br>
                  <ul>
                      <li v-for="error in errors">{{ error }}</li>
                  </ul>
              </div> -->
            <div class="row">
                <div class="col-8">
                    <div class="text-left section-title" style="padding: 5px;">
                        <span class="row-table-font-margins" style='font-family: inherit; font-weight: 600 ; line-height: 1; text-align:center'>
                            Monthly Expenses
                        </span>
                    </div>
                </div>
                
            </div>
          <div class="col-xs-12 col-sm-12 col-md-12">
           
              <div class="col-md-12" style="padding-left: 0; padding-right: 0;">
                <table class="table table-condensed" style="width: 100%;">
                  <thead class="">
                      <tr>
                          <th class="no-border text-center" style="width: 10%;">
                              Invoice No
                          </th>
                          <th class="no-border text-center" style="width: 25%;">
                              Expense Type.
                          </th>
                          <th class="no-border text-center" style="width: 5%;">
                             VAT%.
                          </th>
                          <th class="no-border text-center" style="width: 25%;">
                              Supplier
                          </th>
                          <th class="no-border text-center" style="width: 10%;">
                              Amount
                          </th>
                          <th class="no-border text-center" style="width: 10%;">
                              Net Amount
                          </th>
                          <th class="no-border text-center" style="width: 10%;">
                              VAT Amount
                          </th>
                          <th class="no-border text-center" style="width: 10%;">
                              Date
                          </th>
                          <th class="no-border text-center" style="width: 10%;">
                              Paid
                          </th>
                      </tr>
                  </thead>
                  <tbody>
                      <tr v-for="(expense, index) in expenses" :key="index">
                          <td>
                              <input type="text"
                                     class="form-control"
                                     v-model="expense.invoiceNo" />
                          </td>
                          <td>
                              <select class="form-control"
                                      v-model="expense.expenseTypeId">
                                  <option v-for="(expenseType, index) in expenseTypes"
                                          :key="index"
                                          :value="expenseType.id">
                                      {{ expenseType.name }}
                                  </option>
                              </select>
                              <div v-show="!expense.expenseTypeId & submitted"
                                   class="invalid-feedback"
                                   style>
                                  Expense type is required
                              </div>
                          </td>
                          <td style="text-align:right;">
                              {{ getVATPercentage(expense.expenseTypeId) }}
                          </td>
                          <td>
                              <select id="registered-owner"
                                      class="form-control"
                                      :disabled="expense.expenseTypeId == null"
                                      v-model="expense.supplierId">
                                  <option v-for="supplier in serviceProviderFilter(
                              expense.expenseTypeId
                            )"
                                          v-bind:key="supplier"
                                          :value="supplier.id">
                                      {{ supplier.name }}
                                  </option>
                              </select>
                              <div v-show="!expense.supplierId & submitted"
                                   class="invalid-feedback">
                                  Supplier is required
                              </div>
                          </td>
                          <td>
                              <input type="number"
                                     class="form-control text-right"
                                     v-model="expense.amount"
                                     number
                                     data-type="currency" />
                              <div v-show="!expense.amount & submitted"
                                   class="invalid-feedback">
                                  Amount is required
                              </div>
                          </td>
                          <td style="text-align:right;">
                              {{ $filters.toCurrency(getNetAmount(expense)) }}
                          </td>
                          <td style="text-align:right;">
                              {{ $filters.toCurrency(expense.vatAmount) }}
                          </td>
                          <td>
                              <date-picker class="form-control"
                                           style="height: 36px; border: grey 1px solid;"
                                           :format="customFormatter"
                                           v-model="expense.dueDate" />
                              <div v-show="!expense.dueDate & submitted"
                                   class="invalid-feedback">
                                  Date is required
                              </div>
                          </td>
                          <td>
                              <input class="text-right"
                                     type="checkbox"
                                     name="paid"
                                     v-model="expense.paid" />
                          </td>
                      </tr>
                  </tbody>
                </table>
              </div>
              <div
                class="col-md-2 col-md-offset-5 col-xs-2 col-xs-offset-5"
                style="padding-left: 0; padding-right: 0;"
              >
                <button
                  class="btn btn-primary-reverse"
                  style=""
                  @click="addRow()"
                  onclick="return false;"
                >
                  add row
                </button>
              </div>
           
          </div>
          <div class="col-xs-12 col-sm-12 col-md-12 text-center">
              <div class="text-center">
                  <button type="submit" @click="save()" class="btn btn-submit" style="margin: 15px;">
                      Submit
                  </button>
                  <button @click="closeModal()" class="btn btn-cancel">Cancel</button>
              </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<style scoped>
.invalid-feedback {
  font-size: 14px;
  /* margin-top:-1px; */
  /* color:rgb(56, 56, 56); */
  color: #c7254e;
}
</style>
<script>
import { format } from "date-fns";
export default {
  props: {
    buildingId: {},
    createpdf: {
      type: Function,
    },
  },
  data: function () {
    return {
      expenseTypes: {},
      expenses: {},
      properties: {},
      building: {},
      suppliers: [],
      tempServiceProviders: {},
      building_id: 0,
      month: 0,
      expense_type_id: 0,
      date: "2016-10-16",
      // errors: [],
      newToDoId: 1,
      showTest: true,
      submitted: false,
    };
  },
  watch: {
    value(val) {
      this.$emit("update:buildingId", val);
    },
    buildingId(val) {
      this.value = val;
      this.fetchProperty();
    },
  },

  mounted() {
    this.building_id = this.buildingId;
    //    this.expense_type_id = this.expenseTypeId;
    //    this.month = this.monthProp;
    if (this.buildingId) this.fetchProperty();
  },

  methods: {
    fetchProperty: async function () {
      var request = "/expenses/providers";
      // if(this.route=="home")
      //   request = '/home/statment/get/';
      request = request + "?id=" + this.buildingId;
      this.$http
        .get(request, {
          id: this.buildingId,
        })
        .then(({ data }) => {
          this.mute = false;
          //this.contacts = data.contacts;
          this.mute = false;
          // let myObjStr = JSON.stringify(data.expenseFees);
          this.expenses = data.expenses;
          this.suppliers = data.suppliers;
          this.expenseTypes = data.expenseTypes;
        });
    },
    serviceProviderFilter: function (expenseType_id) {
      var items = this.suppliers;

      var result = items.filter(function (item) {
        return item.serviceTypes.some(
          (x) => x.expenseTypeId && x.expenseTypeId === expenseType_id
        );
      });

      return result;
      },
      getVATPercentage(expenseId) {
          if (expenseId == undefined)
              return 0;
          var expense = this.expenseTypes.find(expenseType => {
              return expenseType.id == expenseId
          })
          
          return expense.vatPercentage
      },
      getNetAmount(expense) {
          var netAmount = 0
          expense.netAmount = 0
          expense.vatAmount = 0
          if (expense == undefined || expense.expenseTypeId == undefined || expense.amount == undefined || expense.amount == 0) {

              expense.netAmount = 0
              expense.vatAmount = 0
              return 0;
          }
          var expenseTemp = this.expenseTypes.find(expenseType => {
              return expenseType.id == expense.expenseTypeId
          })

          netAmount = (expense.amount * 100) / (100 + expenseTemp.vatPercentage)
          
          expense.netAmount = netAmount;
          expense.vatAmount = expense.amount - expense.netAmount;

          return netAmount
      },
    customFormatter(date) {
      return format(date, "dd/MM/yyyy");
    },

    addRow: function () {
      this.submitted = false;
      try {
        //	console.log(index);
        //this.expenses.splice(index + 1, 0, {});
        this.expenses.push({
          //	id: this.newToDoId,
          buildingId: this.buildingId,
        });
        //  this.newToDoId++;
      } catch (e) {
        //  console.log(e);
      }
    },
    removeRow: function (index) {
      this.expenses.splice(index, 1);
    },
    closeModal: function () {
        this.$modal.hide("control-panel-add-form");
    },
    // checkForm: function (e) {

    // 	this.errors = [];

    // 	for(var i =0; i< this.expenses.length; i++) {

    // 		if (!this.expenses[i].expenseTypeId) {
    // 			this.errors.push('Expense type is required.');
    // 		}

    // 		if (!this.expenses[i].supplierId) {
    // 			this.errors.push('Suppliers is required.');
    // 		}

    // 		if (!this.expenses[i].amount) {
    // 			this.errors.push('Amount is required.');
    // 		}

    // 		if (!this.expenses[i].dueDate) {
    // 			this.errors.push('Date is required.');
    // 		}
    // 	}

    //     if (this.errors.length == 0)
    //         return;

    //     e.preventDefault();
    // },
    save() {
      // this.checkForm();
      this.submitted = true;
      /*  window.axios.post('/admin/statment/expenses/save/'+this.building_id,{
                                expenses: this.expenses,
                                //month: this.month,
                                expense_type_id:this.expense_type_id,
                                })
                                .then(response => { 
                                window.location = '/admin/statment/' + this.building_id;
                            
                            })
                            .catch(error => {
                              //  console.log(error.response)
							});*/
      this.$http
        .post("/expenses", {
          expenses: this.expenses,
        })
        .then(
          () => {
            this.closeModal();
           // this.component += 1;
            //this.$forceUpdate();
            location.reload();
            // this.$router.push({name:'controlpanel',params:{buildingId: this.buildingId}})
          },
          () => {
            // alert('error')
            //  this.infoError = true
            //  this.loader = false
            //   this.password = ''
          }
        );
    },
  },

        computed: {
          
        },
};
</script>
